import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8743ec00"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "blogItemTitleBox"
};
const _hoisted_2 = {
  class: "classText"
};
const _hoisted_3 = {
  class: "blogItemTitle"
};
const _hoisted_4 = {
  class: "blogItemCreated_at"
};
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { getBlogFromId } from "@/api/blog.js";
import MdEditor from "md-editor-v3";
import "md-editor-v3/lib/style.css";
export default {
  __name: 'blogDetails',

  setup(__props) {
    const $router = useRouter();
    const blogData = reactive({
      id: 0,
      class_text: '',
      blog_class: 0,
      title: '',
      content: '',
      update_at: ''
    }); // blog_class: 1
    // class_text: "编程入门"
    // content: "# 编程入门基础\n## 1. 什么是编程\n简而言之，编程就是编写程序，通过代码只实现一段可执行的计算机程序。\n那么，问题又来了，**什么是代码**?\n代，有代表/代替的意思；码，就是字符。加起来，就是文字或符号用以代替、代表电子信号。既然如此，那代码必然就是人设计规定的，为了代码的严谨性，就需要指定设计规范\n## 2. 目前比较流行的编程语言有哪些？\n+ ### java\n这是一个成熟的后端编程语言，在国内很多大公司的服务端都是基于该语言编写的\n+ ### python\n这也是一个拥有众多插件的服务端编程语言，更多的被使用在大数据、图像处理、数据分析、人工智能等领域\n+ ### JavaScript（js）\n这是目前最流行的编程语言了，语法简单使用，易上手，是新手入门最推荐的编程语言。\n在这里，必须说明一些，JavaScript和java之间的关系，就好比雷锋与雷峰塔、老婆与老婆饼之间的关系一样，可以说毫不相干。之所以两者如此相像，是因为在JavaScript创建之初，java语言就已经大放异彩了，所有JavaScript的创建者为了蹭java的热度，才取了这样的名字\n因为起初js是运行在浏览器中的语言（后面有了独立于浏览器之外的执行环境，nodejs），所有，只有你的电脑上有浏览器，就能编写执行代码，几乎零门槛\n+ ### golang(go)\n这是一门比较新的语言，是google公司开发的，因为新，所有没有什么历史遗留问题，也因为谷歌公司主导，背靠大树好乘凉，最近的发展也是如火如荼，大有取代java成为后端一哥的势头\n+ ### php\n世界上最好的语言！哈哈哈\n这是php的创建者在他的书上写的话，但已成为编程界或圈内外的笑谈。曾今的php也是不可一世，宽松的代码风格，使得php当初也成为业内的大咖。\n但是，2022了，**强烈不推荐**将php作为自己的主流编程语言进行学习，因为很多php从业者已经开始转go了\n\n当然，编程语言远不止上述这几种，还有鼎鼎大名的C、C++、C#等，以及苹果开发的swift和\nobjective-c等等。但这些，已经不太建议新手作为入门语言进行学习了，读者如有兴趣，可自行了解\n\n## 3. 总结\n编程是一个庞大且复杂的系统，需要有浓厚的兴趣的强大的学习动力才能在编程之路上披荆斩棘\n但是，我仍然相信，哪怕是三分钟热度，也会有三分钟收获，希望读者能有所获益"
    // id: 1
    // title: "第1课：编程入门基础"
    // update_at: "2022-12-07T06:57:49.000Z"

    onMounted(() => {
      console.log("挂载完成");
      document.title = "博客杂记";
      console.log($router.currentRoute.value.query.id); //根据id获取博客详情

      const postData = {
        id: $router.currentRoute.value.query.id
      };
      getBlogFromId(postData).then(res => {
        console.log('根据id获取到了博客结果', res.data.data);
        blogData.id = res.data.data.id;
        blogData.class_text = res.data.data.class_text;
        blogData.blog_class = res.data.data.blog_class;
        blogData.title = res.data.data.title;
        blogData.content = res.data.data.content;
        console.log(MdEditor); // MdEditor.markdownToHTML('#blogContent')

        const date = new Date(res.data.data.update_at);
        blogData.update_at = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes();
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(blogData.class_text), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(blogData.title), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(blogData.update_at), 1)]), _createVNode(_unref(MdEditor), {
        class: "blogItemContent",
        modelValue: blogData.content,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => blogData.content = $event),
        "preview-only": true
      }, null, 8, ["modelValue"])], 64);
    };
  }

};